// возвращает cookie если есть или undefined
const getCookie = (name) => {
    const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
};

// уcтанавливает cookie
const setCookie = (name, value, props) => {
    props = props || {}
    let exp = props.expires
    if (typeof exp == "number" && exp) {
        let d = new Date();
        d.setTime(d.getTime() + exp * 1000);
        exp = props.expires = d;
    }
    if (exp && exp.toUTCString) {
        props.expires = exp.toUTCString();
    }
    value = encodeURIComponent(value)
    let updatedCookie = name + "=" + value
    for (const propName in props) {
        updatedCookie += "; " + propName
        let propValue = props[propName]
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }
    document.cookie = updatedCookie
};

// удаляет cookie
const deleteCookie = (name) => {
    setCookie(name, null, { expires: -1 })
};

export { getCookie, setCookie, deleteCookie };
